import { useEffect, useRef, useState, useCallback, useContext } from 'react'
import { isEqual } from 'lodash'
// import { ReducerContext } from './app'
import { getUser } from './data'
import { getScrollTop, setCurrentUser, toast, dialog, activeLoader, pageLoader, getLoginStatus, removeLastStoreId, getLastStoreId } from './utils'

// export function useDispatch() {
//   return useContext(ReducerContext)
// }

const init = {loading: false, error: null}

export const useService = (service, params) => {
  const prevParams = useRef(null)
  const [callback, status] = useServiceCallback(service)

  useEffect(() => {
    if (params !== null && !isEqual(prevParams.current, params)) {
      prevParams.current = params
      callback(params)
    }
  })

  return status
}

export const useServiceCallback = (service) => {
  const [ status, setStatus ] = useState(init)

  const callback = useCallback(params => {
    const now = params && params.now !== undefined ? params.now : Date.now()
    const payload = params && params.payload || {}

    setStatus({...init, ...status, loading: true})

    service(params)
      .then(res => {
        setStatus({...init, ...status, ...res, ...payload, now, loading: false})
      })
      .catch(error => {
        if (!window.yosBuyerApp) {
          if (navigator.onLine === false) {
            // dialog({
            //   title: '似乎已断开与互联网的连接',
            //   okText: '刷新',
            //   cancelText: '',
            //   onOk: () => {
            //     window.location.reload()
            //   }
            // })
          } else if (Object.prototype.toString.call(error) === '[object Error]') {
            // dialog({
            //   title: '出错了，请稍后刷新页面重试',
            //   okText: '刷新',
            //   cancelText: '',
            //   onOk: () => {
            //     window.location.reload()
            //   }
            // })
          }
        }

        setStatus({...init, error, ...payload, now, loading: false})
      })
  }, [service, status])

  return [callback, status]
}

export const useServiceEffect = (service, params = null, callback = () => {}, num = 1) => {
  const [dataParams, setDataParams] = useState(Object.prototype.toString.call(params) === '[object Object]' ? {...params, now: Date.now()} : params)
  const setCurrentDataParams = useCallback((data) => {
    setDataParams(Object.prototype.toString.call(data) === '[object Object]' ? {...data, now: Date.now()} : data)
  }, [])
  const failRef = useRef('')
  const data = useService(service, dataParams)
  let load = () => {}, success = () => {}
  if (Object.prototype.toString.call(callback) === '[object Function]') {
    success = callback
  } else if (callback) {
    load = callback.load || (() => {})
    success = callback.success || (() => {})
    failRef.current = callback.fail
  }

  useEffect(() => {
    let next, firstLoad = false

    if (dataParams) {
      if (dataParams.activeLoader) {
        // activeLoader({isOpen: data.loading, msg: '加载中', ...(Object.prototype.toString.call(dataParams.activeLoader) === '[object Object]' ? dataParams.activeLoader : {})})
      }

      if (data.now === dataParams.now) {
        if (data.recode === 200) {
          firstLoad = true
          success(data, dataParams)
        } else {
          if (failRef.current) {
            // next = failRef.current(data, dataParams)
            // next && data.msg && toast(data.msg)
            failRef.current(data, dataParams)
          } else {
            // data.msg && toast(data.msg)
          }
        }
      }

      load({...data, nothingShow: !data.loading && firstLoad})
    }
  }, [dataParams, data])

  return num === 2 ? [dataParams, setCurrentDataParams] : setCurrentDataParams
}

// export const useUserService = (callback = () => {}, local = false) => {
//   // const isLogin = getLoginStatus()
//   const successRef = useRef()
//   // const localUser = getCurrentUser()
//   const { user } = useService(getUser, local && !isLogin ? null : '')
//   let currentUser = user || {}

//   setCurrentUser(currentUser)

//   if (!successRef.current && currentUser.id) {
//     successRef.current = true
//     callback(currentUser)
//   }
// }

// export function useNavHidden(hide = false, stillShow) {
//   const scrollTopRef = useRef()
//   const [hidden, setHidden] = useState(hide)

//   const handleTouchStartOrEnd = () => {
//     scrollTopRef.current = getScrollTop()
//   }

//   const handleTouchMove = () => {
//     if (stillShow) return

//     const windowHeight = window.innerHeight
//     const bodyHeight = Math.max(document.documentElement.offsetHeight, document.body.offsetHeight)
//     const scrollTop = getScrollTop()

//     if (windowHeight > bodyHeight || scrollTop === scrollTopRef.current) return

//     setHidden(scrollTop > scrollTopRef.current)
//   }

//   const handleMousewheelScroll = (event) => {
//     if (stillShow) return

//     const delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)))

//     setHidden(delta < 0)
//   }

//   useEffect(() => {
//     scrollTopRef.current = getScrollTop()
//     window.addEventListener('touchstart', handleTouchStartOrEnd, false)
//     window.addEventListener('touchend', handleTouchStartOrEnd, false)
//     window.addEventListener('touchmove', handleTouchMove, false)
//     window.addEventListener('mousewheel', handleMousewheelScroll, false)

//     return () => {
//       window.removeEventListener('touchstart', handleTouchStartOrEnd, false)
//       window.removeEventListener('touchend', handleTouchStartOrEnd, false)
//       window.removeEventListener('touchmove', handleTouchMove, false)
//       window.removeEventListener('mousewheel', handleMousewheelScroll, false)
//     }
//   })

//   return [hidden, setHidden]
// }

export function useDocBackgroundColor(backgroundColor = '#fff') {
  useEffect(() => {
    document.documentElement.style.backgroundColor = backgroundColor

    return () => {
      document.documentElement.style.backgroundColor = ''
    }
  }, [backgroundColor])
}
